module.exports = __webpack_public_path__ + "img/icon_fgyl.2b4026ce.png";